import React from 'react';
import PrivateTourForm from '../admin/PrivateTourForm';

const BACK_TO = '/partner/private-tours';
const SUCCESS_TO = '/partner/private-tours';

export default function PartnerPrivateTourFormPage(props) {
  return (
    <PrivateTourForm
      {...props}
      backTo={BACK_TO}
      successTo={SUCCESS_TO}
    />
  );
}
